import Highway from '@dogstudio/highway'

Highway.initial = false

import {
  AboutRenderer,
  AdvocacyRenderer,
  BlogRenderer,
  CareerRenderer,
  CommunityRenderer,
  DefaultRenderer,
  HomeRenderer,
  ImpactRenderer,
  LeadershipRenderer,
  NewHomePageRenderer,
  PartnershipRenderer,
  ProductsDetailRenderer,
  ProductsRenderer,
  WalgreensRenderer,
} from './renderers'

import SecurityRenderer from './renderers/Security'
import { DefaultTransition } from './transitions'

//TODO: remove the DefaultRenderer assignment, e.g. safe: DefaultRenderer, cahcc: DefaultRenderer, once DefaultRenderer's TODOs (public/src/highway/renderers/Default.js) has been completed
const H = new Highway.Core({
  renderers: {
    default: DefaultRenderer,
    home: HomeRenderer,
    newHomePage: NewHomePageRenderer,
    terms: import('./renderers/Terms'),
    faq: import('./renderers/Terms'),
    leadership: LeadershipRenderer,
    about: AboutRenderer,
    blog: BlogRenderer,
    press: BlogRenderer,
    career: CareerRenderer,
    walgreens: WalgreensRenderer,
    products: ProductsRenderer,
    productsdetail: ProductsDetailRenderer,
    cashout: ProductsDetailRenderer,
    creditMonitoring: ProductsDetailRenderer,
    balanceShield: ProductsDetailRenderer,
    wewin: ProductsDetailRenderer,
    express: ProductsDetailRenderer,
    cashBackRewards: ProductsDetailRenderer,
    productDetail: ProductsDetailRenderer,
    impact: ImpactRenderer,
    community: CommunityRenderer,
    partnership: PartnershipRenderer,
    earnindaygiveaway: import('./renderers/Terms'),
    twelvedaysofpayday: import('./renderers/Terms'),
    bracketgiveaway: import('./renderers/Terms'),
    taxseasongiveaway: import('./renderers/Terms'),
    getawaygiveaway: import('./renderers/Terms'),
    paydaygiveaway: import('./renderers/Terms'),
    munchiesgiveaway: import('./renderers/Terms'),
    lemonadedaygiveaway: import('./renderers/Terms'),
    earningamegiveaway: import('./renderers/Terms'),
    safe: DefaultRenderer,
    cahcc: DefaultRenderer,
    advocacy: AdvocacyRenderer,
    calasiancc: DefaultRenderer,
    termsOfService: DefaultRenderer,
    cashOutTerms: DefaultRenderer,
    electronicComunications: DefaultRenderer,
    nmls: DefaultRenderer,
    fti: DefaultRenderer,
    learn: SecurityRenderer,
    publicResponsibility: SecurityRenderer,
    privacy: import('./renderers/Terms'),
    shortPrivacyNotice: import('./renderers/Terms'),
    fullPrivacy: import('./renderers/Terms'),
    cookieNotice: import('./renderers/Terms'),
    evolveBankAndTrust: import('./renderers/Terms'),
  },

  transitions: {
    default: DefaultTransition,
  },
})

H.on('NAVIGATE_IN', ({ location }) => {
  // console.log("NAVIGATE IN" + JSON.stringify(location));
  const { pathname } = location || {}
  // if (pathname && pathname.includes("/blog/")) {
  const urlParts = pathname.split('/')
  const urlTitle = urlParts && urlParts[urlParts.length - 1]
  let title =
    urlTitle &&
    urlTitle
      .split('-')
      .map((e) => e && e.charAt(0).toUpperCase() + e.slice(1))
      .join(' ')
  title += '| Earnin'
  let metaTitle = document.querySelector('meta[name="title"]')
  if (metaTitle) {
    metaTitle.setAttribute('content', title)
  }
  // }
})

export default H
